import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import router from '@/router'
import { useAppStore } from '@/stores/app'

/**
 * user-web talks to two APIs — user-api under `/api/iiportal-user/` and
 * auth-api under `/api/auth/` — so the instance carries no baseUrl and call
 * sites pass the full path, the same way the axios instance it replaces did.
 */
export const useFetchStore = defineStore('fetch', () => {
    const fetch = createFetch({
        options: {
            updateDataOnError: true,
            beforeFetch({ options }) {
                options.headers = new Headers(options.headers)
                const jwt = localStorage.getItem('JWT')
                if (jwt && jwt !== '') options.headers.set('Authorization', `Bearer ${jwt}`)
                return { options }
            },
            async onFetchError(ctx) {
                if (ctx.response?.status === 401) {
                    const appStore = useAppStore()
                    appStore.setLogout()
                    if (router.currentRoute.value.name !== 'login') {
                        await router.push({ name: 'login' })
                    }
                }
                return ctx
            }
        }
    })

    return { fetch }
})
